import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl, headersDefault } from ".";
import {
  createRequestDedupe,
  SCREEN_ENTRY_THROTTLE_MS,
} from "./requestDedupe";
import axios from "axios";

// The pattern that used to live here — an in-flight promise plus a short
// throttle — is now shared, because five other reads needed exactly the same
// protection. Behaviour is unchanged; see requestDedupe.js.
const courseDedupe = createRequestDedupe({
  throttleMs: SCREEN_ENTRY_THROTTLE_MS,
});
const pillsDedupe = createRequestDedupe({
  throttleMs: SCREEN_ENTRY_THROTTLE_MS,
});

export const getCourse = createAsyncThunk(
  "course/getCourse",
  async () =>
    courseDedupe.run(undefined, async () => {
      const response = await axios.get(
        `${baseUrl}/api/master-club-courses/0/fetch?_=${Date.now()}`,
        { headers: headersDefault() },
      );
      return response.data;
    }),
  { condition: () => !courseDedupe.isFresh() },
);

export const getPills = createAsyncThunk(
  "course/getPills",
  async () =>
    pillsDedupe.run(undefined, async () => {
      const response = await axios.get(`${baseUrl}/api/master-club-pills/list`, {
        headers: headersDefault(),
      });
      return response.data;
    }),
  { condition: () => !pillsDedupe.isFresh() },
);

/** Reset throttle timers — call after actions that change course state. */
export function resetCourseThrottle() {
  courseDedupe.reset();
  pillsDedupe.reset();
}

export const completePill = createAsyncThunk(
  "course/completePill",
  async ({ post_id, is_completed }) => {
    const response = await fetch(
      `${baseUrl}/api/master-club-pills/${post_id}`,
      {
        body: JSON.stringify({ is_completed }),
        method: "PATCH",
        headers: headersDefault(),
      },
    );

    if (response.status !== 200) {
      // The status travels in the error's name, so the pill page can retry a
      // 429 or a 5xx and give up on a 404. The body of those responses is often
      // not JSON at all, which used to turn every one of them into a parse error.
      let serverMessage = null;
      try {
        serverMessage = (await response.json())?.error ?? null;
      } catch (_) {
        serverMessage = null;
      }
      const error = new Error(serverMessage || `HTTP ${response.status}`);
      error.name = `HTTP_${response.status}`;
      throw error;
    }

    return await response.json();
  },
);

// export const completeLesson = createAsyncThunk(
// 	'course/completeLesson',
// 	async ({ pill_id }) => {
// 		const body = {
// 			pill_id,
// 		}

// 		const response = await axios.post(
// 			`${baseUrl}/api/master-club-pills`,
// 			body,
// 			{
// 				headers: headersDefault(),
// 			}
// 		)

// 		return response.data
// 	}
// )
